export const BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME = 'ballotOrdersFileNumber';
export const RA_MEMBER_UPDATED_INFO = 'raMemberUpdatedInfo';
export const TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME = 'userAddressBooks';
export const USER_ID = 'userId';
export const SECUTIX_CONTACT_ID = 'stxContactId';
export const VOD_VIDEO_TITLE_OR_PLAYLIST = 'videoTitleOrPlaylistName';
export const LAST_VISIT_DATE = 'lastVisitDate';
export const USER_STATE_VALID = 'userStateValid';